// Shared formatting helpers for reports.

/** Format a number as USD currency. */
export const fmtUSD = (n) =>
  new Intl.NumberFormat(undefined, {
    style: "currency",
    currency: "USD",
  }).format(Number.isFinite(Number(n)) ? Number(n) : 0);

/** Coerce a Firestore Timestamp | Date | string into a Date (or null). */
export const toDate = (v) => {
  if (!v) return null;
  const d = v?.toDate ? v.toDate() : new Date(v);
  return isNaN(d) ? null : d;
};

/** Whole days between `v` and now (>= 0), or null if no valid date. */
export const daysSince = (v) => {
  const d = toDate(v);
  if (!d) return null;
  return Math.max(0, Math.floor((Date.now() - d.getTime()) / 86400000));
};
